const HeroTypes = {
  DEFAULT: 'default',
  ARTICLE: 'article-hero',
  PAGE: 'page-hero',
  SIGNUP: 'signup-hero',
  SIGNUP_EVENT: 'signup-event-hero',
};

module.exports = HeroTypes;
